<template>
  <div class="date-range-picker" :class="{ time: time }">
    <div class="d-flex align-center flex-grow-1">
      <v-icon class="icon-from">event</v-icon>
      <date-time-picker :label="$t('from')" :clearable="clearable" :value="from" :use-time="time" @input="change($event, to, true)"></date-time-picker>
    </div>

    <v-icon class="icon-arrow">arrow_right_alt</v-icon>

    <div class="d-flex align-center flex-grow-1">
      <v-icon class="icon-to">event</v-icon>
      <date-time-picker :label="$t('to')" :clearable="clearable" :value="to" :use-time="time" @input="change(from, $event)"></date-time-picker>
    </div>
  </div>
</template>

<script>
import DateTimePicker from './date-time-picker.new.vue'

export default {
  props: [ 'value', 'clearable', 'loading', 'time' ],

  computed: {
    from () {
      return this.value ? this.value.from : null
    },

    to () {
      return this.value ? this.value.to : null
    }
  },

  methods: {
    change (from, to, hold) {
      if (from && to && from > to) {
        to = from
      }

      if (from && to && hold) {
        const diff = this.to - this.from
        to = from + diff
      }

      this.$emit('input', { from, to })
      this.$emit('change', { from, to })
    }
  },

  components: {
    DateTimePicker
  }
}
</script>

<style scoped lang="scss">

  @import '../../../assets/responsive';

  .date-range-picker {
    display: flex;
    flex-direction: row;

    .date-time-picker {
      flex-grow: 1;
    }

    .v-icon {
      margin-right: 10px;
      margin-left: 10px;
    }

    .icon-to {
      display: none;
    }


    @include media('<phone') {
      flex-direction: column;
      flex-basis: 0;

      .icon-to {
        display: block;
      }

      .icon-arrow {
        display: none;
        //transform: rotate(90deg);
      }
    }
  }

</style>
